import { Roles } from "config";
import { ILocalizable, commonMessages } from "infrastructure/localization";

export interface IIndustry {
  isiCv4Code: string;
  description: string;
}

export interface ITenant {
  tenantId: string;
  enterpriseId: string;
  name: string;
}

export interface IEnterprise {
  enterpriseId: string;
  name: string;
}

export interface IApiError {
  type?: string;
  localizableMessage?: {
    messageId: string;
    tokens?: {};
  };

  message?: string;
  property?: string;
}

export interface IApiErrorMessage {
  localizable: ILocalizable;
  text?: string;
}

export type IUserRoleAccess = Readonly<Record<keyof typeof Roles, boolean>>;

export const getUserRoleAccessData = (): IUserRoleAccess => {
  return {
    LocalizationManager: false,
    PlexLocalizationManager: false,
    PlexReleaseManager: false,
    PlexSecurityAdmin: false,
    PlexTechnicalWriter: false,
    SecurityAdmin: false,
    Translator: false
  };
};

export const tryExtractLocalizableApiErrorMessage = (error: IApiError): IApiErrorMessage | undefined => {
  let result: IApiErrorMessage | undefined;

  if (error.localizableMessage) {
    result = {
      localizable: {
        messageId: {
          value: error.localizableMessage.messageId
        },
        tokens: error.localizableMessage.tokens
      }
    };
  }

  return result;
};

export const extractApiErrorMessage = (error: IApiError, defaultMessage?: ILocalizable): IApiErrorMessage => {
  const result: IApiErrorMessage = tryExtractLocalizableApiErrorMessage(error) || {
    localizable: defaultMessage || {
      messageId: commonMessages.error("unexpectedError")
    },
    text: error?.message
  };

  return result;
};

export const extractApiErrorMessageContent = (error: IApiError, defaultMessage?: ILocalizable): ILocalizable | string => {
  const apiErrorMessage = extractApiErrorMessage(error, defaultMessage);

  return apiErrorMessage.text || apiErrorMessage.localizable;
};
